var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 700",
    width: 650,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m284.1 37c-77.5 62.4-264.1 55.8-264.1 147 0 50.4 145.6 191.1 137.3 306.6-22.6 314.9 28.2 94.4 167.2 113v-530.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m365.9 37c77.4 62.4 264.1 55.8 264.1 147 0 50.4-151.1 191.8-136.2 306.6 41.4 320.2-29.4 94.4-168.3 113v-530.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperBack);
export default __webpack_public_path__ + "static/media/upper_back.a94b1e0e49fce89711cb54263c4b05ab.svg";
export { ForwardRef as ReactComponent };